export default {
  getCheckManage: "/attendance/getattendancemanagelist",//获取考勤管理列表
  setCheckRecord: "/attendance/setemployeeattendance",//设置考勤状态
  getTime: "/attendance/getattendancerecordbyid/{id}",//添加打卡时间
  getCheckRecord: "/attendance/getattendancerecordlist",//获取考勤记录列表
  getRules: "/attendanceoption/getoptionlist",//获取打卡规则
  addRules: "/attendanceoption/insertoption",//添加打卡规则
  editRules: "/attendanceoption/updateoption",//修改打卡规则
  deleteRules: "/attendanceoption/deleteoption/{id}",//删除打卡规则
}



// WEBPACK FOOTER //
// ./src/api/config/check.js